import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-overtime-rule-by-shifts',
    name: 'pay-overtime-rule-by-shift',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-overtime-rule-by-shift')
  }
]
